export const locale = {
  lang: 'zh2',
  data: {
    'CIERRE': {
      'LABEL1':	'进行中的调研',
      'LABEL2':	'查看进度',
      'LABEL3':	'已完成的调研',
      'LABEL4':	'查看结果',
      'LABEL5': '提醒已发送',
      'LABEL6': '提醒已发送',
      'LABEL7': '您只能在发布日之后发送提醒',
      'LABEL8': '等一下',
      'LABEL9': '剩余天数',
      'BTN_CIERRE':	'关闭',
      'ALERT':{
        'MESSAGE': '您确认要执行预期的调查吗？',
        'BTN_CONFIRM': '是',
        'BTN_CANCEL': '没有',
        'OK':'好',
      },
      'ALERT_RE':{
        'MESSAGE': '¿您确定要发送提醒吗?',
        'BTN_CONFIRM': '是',
        'BTN_CANCEL': '没有',
        'OK':'好',
      },
      'LINK': '转到下一个链接以查看调查的当前进度',
      'LINKENCUESTA': '生成链接以查看调查的当前进度',
      'ACTIONS':{
        'TITULO': '行动',
        'TITULO_ACTUALIZADO': '提醒事项',
        'TITULO_ACCESS': '进入调查',
        'WANNADO': '你想让我做什么？',
        'TITULO_VIRSMS': '虚拟短信门户',
          'TITULO_MYCODE': 'GetMyCode.culturalgo.com门户',
          'TITULO_BTNMYCODE': '转到GetMyCode门户',
      },
      'COMPLETO':{
        'TAG': '调查成功完成',
        'CARDTIT': '结果查询',
        'LINK': '转到下一个链接以查看调查中获得的结果'
      },
      'PULSE':{
        /// Survey advancement
        'LABELPRO':'调查进度',
        'LINKEN':'调查链接',
        'LINKRES':'链接结果',
        'ENCUESTANOENVIADA': '尚未发布脉搏检查问卷',
      },
      'CIERRE':{
        'BCONTEOS':'计数门户',
        'BACCESO':'生成访问密钥',
        'LINKPORTAL': '将访问链接复制到计数门户',
        'COPYLINK':'复制到剪贴板',
        'REMANDER':'提醒事项',
        'REMANDERC2':'提醒尚未完成调查的人',
        'REMANDER1':'提醒尚未参加调查的人',
        'REMANDER2':'提醒已开始但仍未完成的人',
        'GETURLSURV_1': '生成调查访问提供者链接',
        'GETURLSURV_2': '生成了调查访问提供程序的链接，现在您可以通过单击同一按钮来复制它',
        'GETURLSURV_3': '复制调查访问提供者链接',
        'ASIGUSERDEMO':'分配密码',
      },
      'MOD_TEX_SEND_RECO':'发送电子邮件...',
    },
  }
};
